import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Attachment } from '../../models/attachment';

@Component({
  selector: 'app-attachment-list',
  templateUrl: './attachment-list.component.html'
})
export class AttachmentListComponent {
  @Input() attachments: Attachment[] = [];
  @Output() delete = new EventEmitter<number>();
  @Output() download = new EventEmitter<{ id: number, fileName: string }>();

  onDelete(id: number): void {
    this.delete.emit(id);
  }

  onDownload(attachmentId: number, fileName: string): void {
    this.download.emit({ id: attachmentId, fileName });
  }
}
